module.exports = new __parcel__URL__("parcel-seeklogo.fc4ad170.svg").toString();